import BroadcasterPlayer from '@/components/BroadcastComponent/BroadcasterPlayer/BroadcasterPlayer';

export default BroadcasterPlayer;
